import { clearRedirectUrl, updateIsUrlRedirectLoading, updateLoadStatus }
from '@scandipwa/scandipwa/src/store/SearchBar/SearchBar.action';

import XsearchProducts from 'Query/XsearchProducts.query';
import {
    SearchBarDispatcher as SourceSearchBarDispatcher
} from 'SourceStore/SearchBar/SearchBar.dispatcher';

/** @namespace Bodypwa/Store/SearchBar/Dispatcher */
export class SearchBarDispatcher extends SourceSearchBarDispatcher {
    prepareRequest(searchCriteria, dispatch) {
        dispatch(updateLoadStatus(true));

        return XsearchProducts.getQuery(searchCriteria);
    }

    clearRedirectUrl(dispatch) {
        dispatch(clearRedirectUrl());
    }

    setIsUrlRedirectLoading(dispatch) {
        dispatch(updateIsUrlRedirectLoading());
    }

    updateIsUrlRedirectLoading(dispatch, isUrlRedirectLoading) {
        dispatch(updateIsUrlRedirectLoading(isUrlRedirectLoading));
    }
}

export default new SearchBarDispatcher();
